import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { getApi } from '../api';

export default () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      accountId,
      suggestionId,
    }: {
      accountId: number;
      suggestionId: string;
    }) => {
      const { api, baseURL } = getApi();
      return api
        .post(
          `/api/v2/accounts/${accountId}/place-suggestions/${suggestionId}/decline`,
          {},
          { baseURL, useOriginalToken: true },
        )
        .then((res) => res.data.data);
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['place-suggestions', variables.accountId],
      });
    },
  });
};
